function Map() {

    console.log("map");

    var self = this;

    self.setRegion("#americas" , '.americas', '.region-americas');
    self.setRegion("#uk" , '.uk', '.region-uk');
    self.setRegion("#asia-pacific" , '.asia-pacific', '.region-asia-pacific');
    self.setRegion("#europe" , '.europe', '.region-europe');
    self.setRegion("#middle-east-africa" , '.middle-east-africa', '.region-middle-east-africa');


    $("#background").click(function() {

        console.log("click");

        TweenMax.set('.region-text', {autoAlpha:0});
        $('.americas').removeClass("selected");
        $('.africa').removeClass("selected");
        $('.asia-pacific').removeClass("selected");
        $('.europe').removeClass("selected");
        $('.middle-east-africa').removeClass("selected");
        $('.uk').removeClass("selected");
    });


    $("#select-map")

        .select2({

            minimumResultsForSearch: -1

        })
        .on('change', function () {

            console.log("-------------- change");

            $('.americas').removeClass("selected");
            $('.africa').removeClass("selected");
            $('.asia-pacific').removeClass("selected");
            $('.europe').removeClass("selected");
            $('.middle-east-africa').removeClass("selected");
            $('.uk').removeClass("selected");

            var selector = "." + this.value;

            var text = ".region-" + this.value;

            console.log("-------------- text" + text);

            $(selector).addClass("selected");

            TweenMax.set('.region-text', {autoAlpha:0});

            TweenMax.to(text, 0.5, {autoAlpha:1});

        });

}


Map.prototype.setRegion = function (id, selector, text){



    $( id ).mouseover(function() {

        $(selector).addClass("hover");

        // TweenMax.set(selector, {class:'+=selected'});

    }).mouseout(function() {

        $(selector).removeClass("hover");

        //TweenMax.set(selector, {class:'-=selected'});

    }).click(function() {

        $('.americas').removeClass("selected");
        $('.africa').removeClass("selected");
        $('.asia-pacific').removeClass("selected");
        $('.europe').removeClass("selected");
        $('.middle-east').removeClass("selected");
        $('.uk').removeClass("selected");

        TweenMax.set('.region-text', {autoAlpha:0});

        TweenMax.to(text, 0.5, {autoAlpha:1});

        $(selector).addClass("selected");

    });
};

